import {ModalWindow} from "./modalWindow.js";

export class ModalConfirm extends ModalWindow {

   constructor(message, callback) {
      super();

      this.panel.classList.add('dark-transparent');

      const tmpl = document.getElementById('tpl-modal-confirm');
      this.panel.append(tmpl.content.cloneNode(true));
      this.panel.querySelector('.message').innerHTML = message;

      this.panel.querySelector('.ok').addEventListener('click', () => {
         callback(true);
         this.close();
      })

      this.panel.querySelector('.cancel').addEventListener('click', () => {
         callback(false);
         this.close();
      })

      setTimeout(() => this.show(), 1);

   }
}
